
import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";

import { rows } from "./section-loan-hedge-requirements-rows";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanHedgeRequirements extends Component {
  drawDataHedgeRequirements(data) {
    if (data.hedgeRequirements) {
      if (data.hedgeRequirements.requiredHedgeId ||
        data.hedgeRequirements.notional ||
        data.hedgeRequirements.termMonths ||
        data.hedgeRequirements.ratingsRequirements ||
        data.hedgeRequirements.extensions ||
        data.hedgeRequirements.collateralAssignment ||
        data.hedgeRequirements.legalOpinion ||
        data.hedgeRequirements.executionRequirements ||
        data.hedgeRequirements.misc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, eventHandlers, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Hedge Requirements",
            key: LOAN_SECTION_KEYS.HEDGE_REQUIREMENTS,
            isTitleGroup: true,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.HEDGE_REQUIREMENTS}`),
            sections: [
              this.drawDataHedgeRequirements(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.hedgerequirements.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
